import {
    FETCH_ERROR,
    FETCH_START,
    FETCH_SUCCESS,
    INIT_URL,
    ON_HANDOVERS_LIST,
    ON_HANDOVERS_ADD,
    ON_HANDOVERS_UPDATE,
    SHOW_MESSAGE
  } from "../constants/ActionTypes";
  import {adminAPI} from 'util/Api';
  import {getUserDetails} from './Auth';
  



  export const getHandoversList = () => {
    //console.log('Handover list ',getUserDetails());
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
     return (dispatch) => {
         dispatch({type: FETCH_START});
         adminAPI.get('handovers?dui='+getUserDetails().ID+'&scc='+getUserDetails().SCC_ID+'&bac='+getUserDetails().BANK_CODE+'&brc='+getUserDetails().BRANCH_CODE,_data
         ).then(({data}) => { 
           //console.log('Success',data);      
           //alert(data.length);    
         if (data.length) {
           // console.log("Fetched Handover: ", data);
           dispatch({type: FETCH_SUCCESS});
           // format data and store them for use..
           dispatch({type: ON_HANDOVERS_LIST, payload: data});
         } else {
           dispatch({type: FETCH_ERROR, payload: data.error});
         }
       }).catch(function (error) {
         //console.log('Not executing this one', error); 
         dispatch({type: FETCH_ERROR, payload: error.message});
         //console.log("Error****:", error.message);
       });
       }
   }

   export const createHandover = (formValues) => {
    //console.log('newHandover',formValues);
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
    return (dispatch) => {
      dispatch({type: FETCH_START});
      adminAPI.post('handovers', {
            HAND_OVER_BY: getUserDetails().ID,
            TAKE_OVER_BY: formValues.TAKE_OVER_BY,
            ACTION_DATE: '',
            HAND_OVER_AT: '',
            //TAKE_OVER_AT: '',
            SCC_ID: getUserDetails().SCC_ID,
            WITNESSED_BY: formValues.WITNESSED_BY,
            DENOMINATIONS: formValues.DENOMINATIONS,
            REMARKS: formValues.REMARKS,
            APPROVED_BY: formValues.APPROVED_BY,
            APPROVED_AT: '',
            APPROVER_REMARKS: '',
            EMAIL: formValues.EMAIL,
            FULLNAME: formValues.FULLNAME
            
        },_data
      ).then(({data}) => {
         //console.log("data:", data);
        // console.log('success');
        //sessionStorage.setItem("createResp", 'success');
        dispatch({type: FETCH_SUCCESS});
        // dispatch({type: ON_HANDOVERS_ADD, payload: formValues});    
        dispatch({type: SHOW_MESSAGE, payload: "Successful"});    
      }).catch(function (error) {
        //sessionStorage.setItem("createResp", 'error');
        // dispatch({type: FETCH_ERROR, payload: error.message});
        dispatch({type: FETCH_ERROR, payload: "Failed To Update"});
        // console.log("Error****:", error.message);
      });
    }
  };


  export const updateHandover = (newHandover) => {
    // console.log('newHandover');
    // console.log(newHandover);
    // console.log('newHandover');
    //alert('Submited '+JSON.stringify(newHandover))
    // delete newHandover.WITNESSED_BY_SIGNATURE;
    // delete newHandover.HAND_OVER_BY_SIGNATURE;
    // delete newHandover.TAKE_OVER_BY_SIGNATURE;
    // delete newHandover.TAKE_OVER_BY_NAME;
    // delete newHandover.HAND_OVER_BY_NAME;
    // delete newHandover.WITNESSED_BY_NAME;
    // console.log('newHandoverffff');
    // console.log(newHandover);
    // console.log('newHandoverffff');
    // alert(JSON.stringify(newHandover))
    let token = sessionStorage.getItem('token');
   
    const _data = {
       headers: {
           Authorization: `Bearer ${token}`,
       }
      // data: {}
    };
    return (dispatch) => {
      dispatch({type: FETCH_START});
      adminAPI.put('handovers?hid='+parseInt(newHandover.ID), {
            //USER_ID: JSON.parse(sessionStorage.getItem('user')).ID,
            //HAND_OVER_BY: newHandover.HAND_OVER_BY,
            TAKE_OVER_BY: newHandover.TAKE_OVER_BY,
            //ACTION_DATE: newHandover.ACTION_DATE,
            //HAND_OVER_AT: newHandover.HAND_OVER_AT,
            //TAKE_OVER_AT: newHandover.TAKE_OVER_AT,
            SCC_ID: newHandover.SCC_ID,
            WITNESSED_BY: newHandover.WITNESSED_BY,
            DENOMINATIONS: newHandover.DENOMINATIONS,
            REMARKS: newHandover.REMARKS,
            STATUS: newHandover.STATUS,
            APPROVED_BY: newHandover.APPROVED_BY,
            //APPROVED_AT: newHandover.APPROVED_AT,
            APPROVER_REMARKS: " "
        },_data
      ).then(({data}) => {
         //console.log("data:", data);
        // console.log('success');
        //sessionStorage.setItem("createResp", 'success');
        dispatch({type: FETCH_SUCCESS});
        dispatch({type: SHOW_MESSAGE, payload: "Successful"});  
        
    //history.push('/app/handovers/list');  
      }).catch(function (error) {
        //sessionStorage.setItem("createResp", 'error');
        dispatch({type: FETCH_ERROR, payload: "Failed To Update"});
         //console.log("Error****:", error.message);
         //return (<Redirect to={'/app/handovers/list'}/>);
    //history.push('/app/handovers/list');
      });
    }
  };
